<template>
  <div class="manage-plan-dialog">
    <v-snackbar
        v-model="snackbar.error"
        color="error"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.errorMessage }}
    </v-snackbar>
    <v-snackbar
        v-model="snackbar.success"
        color="success"
        :multi-line="true"
        :timeout="snackbar.timeout" >
      {{ snackbar.successMessage }}
    </v-snackbar>

    <ConfirmPlanChangeDialog :payment-info="ccInfo" :on-close="onPlanChanged" />
    <v-dialog v-model="showManagePlanDialog"  scrollable>
      <LoadingDialog v-model="showLoadingDialog" />

      <v-card color="#f0f0f0">
        <v-card-title class="pl-4 pr-4">
          <h2>Manage Plan</h2>
          <v-spacer />
          <v-btn flat icon color="itoviGrayMid" @click="close()"><v-icon>close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pt-0" v-if="plan.can_change_plan">
            <v-card class="mb-4" flat v-if="plan.name === 'Hold' || plan.status === 'paused' ">
                <v-card-text class="text-xs-left">
                    <div class="mb-1 plan-title itoviPrimary--text">Reactivate {{ original_plan.name || null }} </div>
                    <v-divider class="mt-2 mb-2" />
                    <v-layout align-center row wrap>
                        <span class="txt-semi-bold">Monthly:&nbsp;</span>
                        <span class="txt-semi-bold">${{ formatPrice(original_plan.price || null) }}</span>
                        <span class="txt-semi-bold txt-subscript">&nbsp;/ mo</span>
                    </v-layout>
                    <div class="mb-2">{{ original_plan.description || null }}</div>
                    <!--      what's included section          -->
                    <div v-if="!!original_plan.included && original_plan.included.length > 0" class="mt-2 mb-2">
                        <ul>
                            <template v-for="(upgradeDetailsIncludedItem, index2) in original_plan.included">
                                <li :key="index2">{{ upgradeDetailsIncludedItem }}</li>
                            </template>
                        </ul>
                    </div>
                    <v-layout align-center column>
                        <button v-if="plan.status === 'active'" @click="showConfirmPlanChangeDialog(original_plan)" class="button-blue">Activate Now</button>
                        <button v-else @click="$store.commit('setShowPayDialog', true);" class="button-blue">Activate Now</button>
                        <div v-if="ccInfo && ccInfo.last_four" class="mt-2">
                            *Your card ending in
                            <strong>{{ ccInfo.last_four }}</strong> will be charged
                            <strong>${{ formatPrice(original_plan.price || null) }}
                                <span class="txt-button-blue" @click="openCcDialog()">
                                    Update Card
                                </span>
                            </strong>
                        </div>
                        <div v-else>No card on file <span>Update Payment</span></div>
                    </v-layout>
                </v-card-text>
            </v-card>
          <h3 class="text-xs-left mb-2">Current Plan:</h3>
          <family-plan v-if="plan.product_code && plan.product_code.match(familyRegex)" />
          <v-card v-else class="mx-auto">
            <v-card-text class="text-xs-left">
                <div class="mb-1 plan-title itoviPrimary--text">{{ plan.name }}</div>
                <v-divider class="mt-2 mb-2" />
                <v-layout align-center row wrap class="mb-2">
                    <span class="txt-semi-bold">Monthly:&nbsp;</span>
                    <span class="txt-semi-bold">${{ formatPrice(plan.monthly) }}</span>
                    <span class="txt-semi-bold txt-subscript">&nbsp;/ mo</span>
                </v-layout>
                  <!--      what's included section          -->
                <div v-if="!!plan.details.included && plan.details.included.length > 0" class="mt-2 mb-2">
                    <ul>
                      <template v-for="(upgradeDetailsIncludedItem, index2) in plan.details.included">
                        <li :key="index2">{{ upgradeDetailsIncludedItem }}</li>
                      </template>
                    </ul>
                </div>
                <v-layout v-if="plan.name === 'Hold'">
                    <img src="../../../assets/hold_icon.svg" class="mr-1 mb-1" height="22" width="22" alt="hold"/>
                    <v-flex>{{ plan.details.description }}</v-flex>
                </v-layout>
                <v-layout v-if="plan.status === 'paused'">
                    <img src="../../../assets/paused_icon.svg" class="mr-1 mb-1" height="22" width="22" alt="paused"/>
                    <v-flex>Your account is paused due to failed payments</v-flex>
                </v-layout>
            </v-card-text>
          </v-card>

          <h3 v-if="plan.upgradeable_plans && plan.upgradeable_plans.length > 0 || plan.family_plans && plan.family_plans.length > 0" class="text-xs-left mt-4 mb-2">Available Plans:</h3>

          <v-expansion-panel v-if="plan.upgradeable_plans && plan.upgradeable_plans.length > 0">
            <family-plan v-if="(plan.status === 'paused' ||  plan.name === 'Hold') && plan.family_plans && plan.family_plans.length > 0 && !plan.product_code.match(familyRegex)" />
            <v-expansion-panel-content :key="index" v-for="(item, index) in plan.upgradeable_plans.filter((up) => {
                if (up.product_code === 'ORIGINAL') {
                  return
                }
                return up
                })"
            >
              <template v-slot:header>
                <div class="plan-title itoviPrimary--text">{{ item.name }}</div>
              </template>
              <v-divider />
              <v-card class="pl-4 pr-4 pt-1 pb-2">
                <div class="mb-2">{{ item.description }}</div>
                <v-layout align-center row wrap>
                  <span class="txt-semi-bold">Price:&nbsp;</span>
                  <span class="txt-semi-bold">${{ formatPrice(item.price) }}</span>
                </v-layout>
                <v-layout align-center row wrap>
                  <span class="txt-semi-bold">Monthly:&nbsp;</span>
                  <span class="txt-semi-bold">${{ formatPrice(item.monthly) }}</span>
                  <span class="txt-semi-bold txt-subscript">&nbsp;/ mo</span>
                </v-layout>

                <!--      what's included section          -->
                <div v-if="!!item.included && item.included.length > 0" class="mt-2">
                  <ul>
                    <template v-for="(updradeDetailsIncludedItem, index2) in item.included">
                      <li :key="index2">{{ updradeDetailsIncludedItem }}</li>
                    </template>
                  </ul>
                </div>
                <v-layout justify-center wrap class="mt-2">
                  <button v-if="!isAppView" @click="showConfirmPlanChangeDialog(item)" class="button-blue-outline">Change Plan to {{ item.name }}</button>
                  <div class="text-xs-center" v-else >Log in to your iTOVi dashboard from a web browser to change your plan to <b>{{ item.name }}</b></div>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card-text>
        <v-card-text class="pt-0" v-else>
          <v-card class="mx-auto mt-2" >
              <v-card-text class="text-xs-left">
                  To reactivate your account, please contact our customer support team:<br><br>
                  877-483-3748<br>
                  support@itovi.com<br><br>
                  MONDAY – FRIDAY<br>
                  8am ~ 6pm (MST)<br>
                  SATURDAY<br>
                  10am ~ 5pm (MST)
              </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import store from "@/store"
  import { formatPrice } from "../../../helpers/priceHelper"
  import LoadingDialog from "../../LoadingDialog"
  import ConfirmPlanChangeDialog from "./ConfirmChangePlanDialog"
  import subscribeToStore from "@/mixins/subscribeToStore";
  import FamilyPlan from "@/components/dashboard/yourPlanCard/FamilyPlan";

  export default {
    components: {
      LoadingDialog,
      ConfirmPlanChangeDialog,
      FamilyPlan
    },
    data: ()=> ({
      showUpdateCcDialog: false,
      familyRegex: /FAMILY\+[0-9]+/,
      showManagePlanDialog: store.state.showManagePlanDialog,
      ccInfo: store.state.ccInfo,
      isAppView: store.state.isAppView,
      showLoadingDialog: false,
      snackbar: {
        success: false,
        error: false,
        timeout: 1500,
        errorMessage: "An unknown error occurred",
        successMessage: "Address updated successfully"
      },
      original_plan: {},
    }),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      plan: {
        type: Object,
        default: () => ({// this could be "On Hold" - in which case one of their "Upgradeable Plans" is their actual plan (like Basic)
          name: '',
          product_code: '',
          status:'',
          monthly: null,
          details: {
            included: [],
            description: null,
          },
          upgradeable_plans: [
            {
              id: 0,
              name: '',
              price: 0,
              monthly: 0,
              details: {
                included: [],
                description: null,
              },
              product_code: ""
            },
          ],
        })
      },
    },
    mixins: [subscribeToStore],
    mounted() {
      this.subscribeToStore(['isAppView', 'ccInfo', 'showManagePlanDialog']);
      this.getUpgradeablePlan();
    },
      methods: {
      formatPrice : formatPrice,
      openCcDialog() {
        this.$store.commit('setShowUpdateCcDialog',true)
      },
      close() {
        store.commit('setShowManagePlanDialog', false);
      },
      onPlanChanged(success) {
        if (success) {
          this.show = false
        }
      },
      async showConfirmPlanChangeDialog(plan) {
        // console.log(plan)
        // the the payment info so we can tell the user what card they are paying with
        this.ccInfo = store.state.ccInfo
        store.commit('setPlanToConfirm', plan);
        store.commit('setShowConfirmDialog', true);
      },
      getUpgradeablePlan() {
        const original_plan = this.plan.upgradeable_plans ? this.plan.upgradeable_plans.filter((plan) => plan.product_code === "ORIGINAL") : null;
        if(original_plan && original_plan.length) {
          this.original_plan = original_plan[0];
        }
        else {
          this.original_plan = this.plan;
        }
      },
    }
  }
</script>
